import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
  Divider
} from '@mui/material';

/**
 * Компонент для редактирования карточек мини-игр
 */
const GameCardsEditor = ({ gameType, config, onConfigChange }) => {
  const handleCardChange = (index, field, value) => {
    const newConfig = Array.isArray(config) ? [...config] : [];
    if (newConfig[index]) {
      newConfig[index] = { ...newConfig[index], [field]: parseFloat(value) || value };
      onConfigChange(newConfig);
    }
  };

  // Cosmic Dice - 11 карточек
  if (gameType === 'cosmic_dice') {
    const cards = config || [];

    return (
      <Box sx={{ mt: 2 }}>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ mb: 2 }}>🎲 Карточки игры "Космические кости"</Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Число</strong></TableCell>
                <TableCell><strong>Шанс победы</strong></TableCell>
                <TableCell><strong>Буст доходности (%)</strong></TableCell>
                <TableCell><strong>Длительность буста (сек)</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cards.map((card, index) => (
                <TableRow key={index}>
                  <TableCell>{card.num}</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      inputProps={{ step: 0.01, min: 0, max: 1 }}
                      value={card.chance || 0}
                      onChange={(e) => handleCardChange(index, 'chance', e.target.value)}
                      sx={{ width: 100 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      value={card.boost || 0}
                      onChange={(e) => handleCardChange(index, 'boost', e.target.value)}
                      sx={{ width: 100 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      value={card.duration || 0}
                      onChange={(e) => handleCardChange(index, 'duration', e.target.value)}
                      sx={{ width: 100 }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  // Asteroid Miner - 9 карточек
  if (gameType === 'asteroid_miner') {
    const cards = config || [];

    return (
      <Box sx={{ mt: 2 }}>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ mb: 2 }}>⛏️ Карточки игры "Майнер астероидов"</Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Астероид</strong></TableCell>
                <TableCell><strong>Тип</strong></TableCell>
                <TableCell><strong>Джекпот</strong></TableCell>
                <TableCell><strong>Хорошо</strong></TableCell>
                <TableCell><strong>Мало</strong></TableCell>
                <TableCell><strong>Пусто</strong></TableCell>
                <TableCell><strong>Длит. буста (сек)</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cards.map((card, index) => (
                <TableRow key={index}>
                  <TableCell>{card.value}</TableCell>
                  <TableCell>{card.type}</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      inputProps={{ step: 0.01, min: 0, max: 1 }}
                      value={card.jackpot || 0}
                      onChange={(e) => handleCardChange(index, 'jackpot', e.target.value)}
                      sx={{ width: 80 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      inputProps={{ step: 0.01, min: 0, max: 1 }}
                      value={card.good || 0}
                      onChange={(e) => handleCardChange(index, 'good', e.target.value)}
                      sx={{ width: 80 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      inputProps={{ step: 0.01, min: 0, max: 1 }}
                      value={card.small || 0}
                      onChange={(e) => handleCardChange(index, 'small', e.target.value)}
                      sx={{ width: 80 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      inputProps={{ step: 0.01, min: 0, max: 1 }}
                      value={card.empty || 0}
                      onChange={(e) => handleCardChange(index, 'empty', e.target.value)}
                      sx={{ width: 80 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      value={card.duration || 0}
                      onChange={(e) => handleCardChange(index, 'duration', e.target.value)}
                      sx={{ width: 80 }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  // Meteor Race - 4 ракеты
  if (gameType === 'meteor_race') {
    const cards = config || [];

    return (
      <Box sx={{ mt: 2 }}>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ mb: 2 }}>🏃 Карточки игры "Гонка метеоров"</Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Ракета</strong></TableCell>
                <TableCell><strong>Шанс победы</strong></TableCell>
                <TableCell><strong>Длительность буста (сек)</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cards.map((card, index) => (
                <TableRow key={index}>
                  <TableCell>Ракета {card.rocket}</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      inputProps={{ step: 0.01, min: 0, max: 1 }}
                      value={card.chance || 0}
                      onChange={(e) => handleCardChange(index, 'chance', e.target.value)}
                      sx={{ width: 100 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      value={card.duration || 0}
                      onChange={(e) => handleCardChange(index, 'duration', e.target.value)}
                      sx={{ width: 100 }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  // Lunar Lottery - 3 карточки
  if (gameType === 'lunar_lottery') {
    const cards = config || [];

    return (
      <Box sx={{ mt: 2 }}>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6" sx={{ mb: 2 }}>🎰 Карточки игры "Лунная лотерея"</Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Совпадений</strong></TableCell>
                <TableCell><strong>Множитель</strong></TableCell>
                <TableCell><strong>Длительность буста (сек)</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cards.map((card, index) => (
                <TableRow key={index}>
                  <TableCell>{card.matches}</TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      value={card.multiplier || 0}
                      onChange={(e) => handleCardChange(index, 'multiplier', e.target.value)}
                      sx={{ width: 100 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      value={card.duration || 0}
                      onChange={(e) => handleCardChange(index, 'duration', e.target.value)}
                      sx={{ width: 100 }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  // Star Flip - карточки не нужны, только общий шанс победы
  // Настройки задаются в общих параметрах игры

  return null;
};

export default GameCardsEditor;
